import isEmpty from 'lodash/isEmpty';
import * as ReactGA from 'react-ga';

import extractFields from './extractFields';

export default class GoogleAnalyticsTracker {
  constructor(id) {
    this.id = id;
    this.initialized = false;
  }

  init = () => {
    if (!this.initialized) {
      ReactGA.initialize(this.id, {
        debug: process.env.NODE_ENV === 'development',
      });
      this.initialized = true;
    }
  };
  setFields = data => {
    if (!isEmpty(data)) {
      const {
        communityId,
        eventId,
        productId,
        userId,
      } = extractFields(data);
      const fields = {};
      if (eventId) {
        fields.dimension1 = eventId;
      }
      if (communityId) {
        fields.dimension2 = communityId;
      }
      if (productId) {
        fields.dimension3 = productId;
      }
      if (userId) {
        fields.userId = userId;
      }
      if (!isEmpty(fields)) {
        ReactGA.set(fields);
      }
    }
  };
  trackEvent = (category, action, fields) => {
    this.init();
    if (fields) {
      this.setFields(fields);
    }
    ReactGA.event({
      category,
      action,
    });
  };
  trackException = (description, fields, fatal = false) => {
    this.init();
    if (fields) {
      this.setFields(fields);
    }
    ReactGA.exception({
      description,
      fatal,
    });
  };
  trackOutboundLink = (label, fields, cb) => {
    this.init();
    if (fields) {
      this.setFields(fields);
    }
    ReactGA.outboundLink({ label }, () => cb && cb());
  };
  trackPageView = (path, title, fields) => {
    this.init();
    if (fields) {
      this.setFields(fields);
    }
    ReactGA.pageview(path, null, title);
  };
}
